




































  import { Component, mixins } from 'nuxt-property-decorator'
  import LazyHydrate from 'vue-lazy-hydration'
  import { namespace } from 'vuex-class'
  import pages from '../breadcrumbs'
  import SeoMethodsMixin from '~/mixins/SeoMethodsMixin'
  import { TranslateResult } from '~/types'

  const cms = namespace('cms')

  @Component({
    middleware: ['isAuthenticatedOrPlatformOpened'],
    meta: {
      breadcrumb: {
        name: pages.BLOG,
        link: '/blog',
      },
    },
    components: {
      LazyHydrate,
      OneBlogTile: () => import('~/components/molecules/tiles/OneBlogTile.vue'),
    },
    watchQuery: ['tag'],
  })
  export default class Index extends mixins<SeoMethodsMixin>(SeoMethodsMixin) {
    @cms.Getter articlesListItems: any
    @cms.Getter articlesPageNumber: any
    @cms.Getter articlesPageSize: any
    @cms.Getter articlesTotalItems: any
    @cms.Getter articleTagByName: any
    @cms.Action fetchArticles: any

    pageNumber: number = 1
    showBtn: boolean = false

    tagIds(queryTag: string | Array<string>) {
      const tags = this.queryWithCommaToArray(queryTag)

      return (
        tags &&
        tags.map((tag: string) => {
          return this.articleTagByName(tag) && this.articleTagByName(tag).id
        }).filter((tag: string) => tag))
    }

    // possibility to handle this kind of queries /blog?tag=Nowosci,Promocje or /blog?tag=Promocje&tag=Nowosci
    queryWithCommaToArray(queryTags: string | Array<string>): Array<string> {
      let tags = queryTags
      if (typeof queryTags === 'string' || queryTags instanceof String) {
        tags = queryTags.split(',')
      }
      return tags as Array<string>
    }

    get blogTitle(): TranslateResult {
      const tags = this.queryWithCommaToArray(this.$route.query.tag as string | Array<string>)
      const tagNames =
        tags &&
        tags.map((tag: string) => {
          return this.articleTagByName(tag) && this.articleTagByName(tag).name
        }).filter((tag: string) => tag)
      return (tagNames && tagNames[0] && tagNames[0].toUpperCase()) || this.$t('blog.title')
    }

    async fetch({ store, route }: any) {
      store.commit('layout/TOGGLE_BREADCRUMBS', true)
      await store.dispatch('cms/fetchArticleTags')

      let queryTags = route.query && route.query.tag
      if (typeof queryTags === 'string' || queryTags instanceof String) {
        queryTags = queryTags.split(',')
      }

      const tagIds =
        queryTags &&
        queryTags.map((tag: string | null) => store.getters['cms/articleTagByName'](tag) && store.getters['cms/articleTagByName'](tag).id)
          .filter((tag: string) => tag)
      await store.dispatch('cms/fetchArticles', {
        pageNumber: this.pageNumber,
        pageSize: this.articlesPageSize,
        tags: tagIds || [],
      })
      return Promise.resolve()
    }

    paginationChange(page: number) {
      const tagIds = this.tagIds(this.$route.query.tag as string | Array<string>)
      this.fetchArticles({
        pageNumber: page,
        pageSize: this.articlesPageSize,
        tags: tagIds || [],
      })
    }
  }
